import React from 'react';
import {
  CalendarIcon,
  UserIcon,
  ArrowRightStartOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

interface NavigationIconProps {
  className?: string;
}

export const CalendarNavIcon: React.FC<NavigationIconProps> = ({ className = 'h-6 w-6' }) => (
  <CalendarIcon
    className={className}
    style={{
      stroke: 'url(#brand-gradient)',
      strokeWidth: '2',
    }}
  />
);

export const ProfileNavIcon: React.FC<NavigationIconProps> = ({ className = 'h-6 w-6' }) => (
  <UserIcon
    className={className}
    style={{
      stroke: 'url(#brand-gradient-profile)',
      strokeWidth: '2',
    }}
  />
);

export const SignOutNavIcon: React.FC<NavigationIconProps> = ({ className = 'h-6 w-6' }) => (
  <ArrowRightStartOnRectangleIcon
    className={className}
    style={{
      stroke: 'url(#brand-gradient)',
      strokeWidth: '2',
    }}
  />
);

export const HamburgerMenuIcon: React.FC<NavigationIconProps> = ({ className = 'h-6 w-6' }) => (
  <Bars3Icon
    className={className}
    style={{
      stroke: 'currentColor',
      strokeWidth: '2',
    }}
  />
);

export const CloseMenuIcon: React.FC<NavigationIconProps> = ({ className = 'h-6 w-6' }) => (
  <XMarkIcon
    className={className}
    style={{
      stroke: 'currentColor',
      strokeWidth: '2',
    }}
  />
);
